import type { ChartIdOperator, IdField } from '../hooks/use-chart-id-search'

const MASK = /^\*+$/
/** A value the user may see: not missing, not fully masked ("*****"). */
export const isShown = (v: string | null | undefined): v is string => !!v && !MASK.test(v)

/** A bulk search's identifier condition: which column it matched and against which values. */
export interface IdHit { field: IdField; operator: ChartIdOperator; values: string[] }

/**
 * How many leading characters of `text` the bulk search matched (0 = none):
 * exact — the whole value when it equals a searched one; prefix — the longest
 * searched value it starts with. Case-insensitive; a hint only (the server matched).
 */
export function idHitLength(text: string, hit: Pick<IdHit, 'operator' | 'values'>): number {
  const t = text.toLowerCase()
  let best = 0
  for (const v of hit.values) {
    const k = v.trim().toLowerCase()
    if (!k) continue
    if (hit.operator === 'exact' ? t === k : t.startsWith(k)) best = Math.max(best, k.length)
  }
  return best
}
